import About from './components/About.vue'
import AppInfo from './components/AppInfo.vue'
import ActivateAccount from './components/ActivateAccount.vue'
import Contact from './components/Contact.vue'
import CreateAccount from './components/CreateAccount.vue'
import Dashboard from './components/Dashboard.vue'
import DeviceLinking from './components/DeviceLinking.vue'
import DeviceManagement from './components/DeviceManagement.vue'
import Faq from './components/Faq.vue'
import GetStarted from './components/GetStarted.vue'
import Landing from './components/Landing.vue'
import Login from './components/Login.vue'
import Setup from './components/Setup.vue'
import Slider from './components/Slider.vue'
import Slider2 from './components/Slider2.vue'
import SlideshowEditor from './components/SlideshowEditor.vue'
import Solutions from './components/Solutions.vue'
import ResetPassword from './components/ResetPassword.vue'

const routes = [
  { path: '/', component: Landing, name: 'landing' },
  { path: '/about', component: About, name: 'about' },
  { path: '/app-info', component: AppInfo, name: 'app-info' },
  { path: '/activate-account/:hash', component: ActivateAccount, name: 'activate-account', props: true },
  { path: '/contact', component: Contact, name: 'contact' },
  { path: '/create-account', component: CreateAccount, name: 'create-account' },
  { path: '/dashboard', component: Dashboard, name: 'dashboard' },
  { path: '/device-management', component: DeviceManagement, name: 'device-management' },
  { path: '/faq', component: Faq, name: 'faq' },
  { path: '/get-started', component: GetStarted, name: 'get-started' },
  { path: '/login', component: Login, name: 'login' },
  // TODO
  // { path: '/device', component: ActivateDevice, name: 'activate-device' },
  { path: '/device-linking', component: DeviceLinking, name: 'device-linking' },
  { path: '/setup', component: Setup, name: 'setup' },
  { path: '/slideshow-editor', component: SlideshowEditor, name: 'slideshow-editor' },
  { path: '/slider', component: Slider, name: 'slider', props: true },
  { path: '/slider2', component: Slider2, name: 'slider2', props: true },
  { path: '/solutions', component: Solutions, name: 'solutions' },
  { path: '/reset-password/:hash', component: ResetPassword, name: 'reset-password', props: true }
]

export default routes
